/* eslint-disable camelcase */
import { BookedSendingMission, SendingMissionDate, SndMissionSupportSave } from 'src/modules/support/models/bookedSendingMission';
import AxiosInstance from './axios/interceptor';

const controller = 'SndMission';

// Produktionsdatumen, nyast först. Egen endpoint eftersom den vanliga datumlistan bara ger kommande datum.
export const getSendingMissionDates = () => AxiosInstance.get<SendingMissionDate[]>(`${controller}/Dates`);

// Uppdragen för ett produktionsdatum (eller för en kund).
export const getBookedSendingMissions = (sndDateId?: number, customerId?: number) => {
  const params = new URLSearchParams();
  if (sndDateId) params.append('sndDateId', String(sndDateId));
  if (customerId) params.append('customerId', String(customerId));

  const query = params.toString();

  return AxiosInstance.get<BookedSendingMission[]>(`${controller}/Booked${query ? `?${query}` : ''}`);
};

// Sparar status och kommentar för de rader som ändrats. Returnerar antalet sparade rader.
export const saveBookedSendingMissions = (items: SndMissionSupportSave[]) => AxiosInstance.put<number>(`${controller}/Booked`, items);
